"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.learningComponent = exports.LearningComponent = void 0;
const app_1 = require("app");
const dictionary_1 = require("Views/Partials/Components/TableCore/dictionary");
const LearningComponent_1 = require("./components/LearningComponent");
const LearningDataService_1 = require("./services/LearningDataService");
class LearningComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.learning-component-table';
    }
    OnInit() {
        this.el.forEach((el, index) => {
            this.renderLearningComponent(el, index);
        });
    }
    renderLearningComponent(el, _index) {
        const dictionary = (0, app_1.transformDictionary)(dictionary_1.tableDictionary, app_1.AttrService.data(el, 'dictionary'));
        const searchUrl = el.getAttribute('data-learning-search-url');
        const searchParams = {
            query: el.getAttribute('data-learning-search-query'),
            language: el.getAttribute('data-language'),
        };
        const tableCaption = el.dataset['tableCaption'];
        const tileStatusExpanded = app_1.AttrService.data(el, 'tile-status-expanded');
        (0, LearningComponent_1.RenderLearningComponent)({
            dataService: new LearningDataService_1.LearningDataService(searchUrl, searchParams),
            dictionary: dictionary,
            tableCaption: tableCaption,
            tileStatusExpanded: tileStatusExpanded === 'True',
        }, el);
    }
}
exports.LearningComponent = LearningComponent;
exports.learningComponent = new LearningComponent();
